import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './allhomes-listing-no-search-results.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var NewSearchPageNoResults = _ref => {
  var isNewListings = _ref.isNewListings;
  return ___EmotionJSX("section", {
    css: styles.content
  }, ___EmotionJSX("div", {
    className: "allhomes-listing-no-search-results__contents"
  }, ___EmotionJSX("img", {
    src: "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-listing-search-results/static/no-results_ab1f0f17.png",
    css: styles.image,
    alt: "No properties match your search right now"
  }), ___EmotionJSX("div", {
    css: styles.text
  }, "No properties match your search right now. You could:"), ___EmotionJSX("ul", {
    css: styles.actions
  }, ___EmotionJSX("li", null, "choose a different region", isNewListings && ' or date', "."))));
};
NewSearchPageNoResults.propTypes = {
  isNewListings: PropTypes.bool
};
NewSearchPageNoResults.defaultProps = {
  isNewListings: false
};
export default NewSearchPageNoResults;